import React from "react";

const Shop = () => {
    return (
        <section>
            <h1>Services Offered</h1>
            <ul>
                <li>Fashion</li>
                <li>Portrait</li>
                <li>Wedding&nbsp;Portfolio</li>
                <li>Commercial&nbsp;Projects</li>
                <li>Life&nbsp;Style</li>
                <li>Couple&nbsp;Shoots</li>
                <li>Travel&nbsp;and&nbsp;Landscape</li>
            </ul>
        </section>
    );
}

export default Shop;
